export const downloadFile = (url: string, filename = ''): void => {
  const link = document.createElement('a');

  link.href = url;
  link.target = '_blank';
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
